<style scoped>
@media print {
  body * {
    visibility: hidden;
  }

  #modal-print,
  #modal-print * {
    visibility: visible;
  }

  #modal-print {
    position: absolute;
    inset: 0;
    background: white !important;
  }
}
</style>
<template>
  <!-- Fondo semitransparente -->
  <transition name="fade">
    <div v-if="visible" class="fixed inset-0 bg-black/50 backdrop-blur-sm
         flex items-center justify-center z-50 p-6">
      <!-- Modal -->
      <div class="bg-white  w-full   max-w-5xl h-full p-5 transform transition-all flex flex-col overflow-hidden">

        <div class="flex justify-start ">
          <span
            class="text-xs text-indigo-500 font-mono bg-indigo-50 px-3 py-1 rounded-full shadow-sm">&#60;ModalDetalleEjecucionPresupuestaria&#62;</span>
        </div>

        <!-- ================= HEADER ================= -->
        <div class="border-b p-5 flex justify-between items-start shrink-0">

          <div class="flex-1 text-center space-y-3">
            <h2 class="text-xl font-semibold font-mono text-gray-800  ">
              Informe Ejecución Presupuestaria {{ descripcion_libromayor }} v.1
            </h2>
          </div>

          <button @click="cerrar" class="text-gray-400 hover:text-gray-600 transition text-2xl leading-none ml-4">
            ✕
          </button>
        </div>

        <!-- ================= CONTENIDO SCROLL ================= -->
        <div class="flex-1 overflow-y-auto">

          <div v-if="centro_cuentas.length == 0" class=" px-6 py-4 border-b flex justify-between items-center">

            <p class="text-sm text-red-800 font-mono mt-3 ">
              {{ `No hay detalle de ejecución presupuestaria ` }}
            </p>
          </div>
          <div v-for="centro in centro_cuentas" :key="centro.id"
            class="mb-10 bg-white shadow-lg rounded-2xl border border-gray-200 overflow-hidden">

            <!-- Header tarjeta -->
            <div class="bg-gray-50 px-6 py-4 border-b flex justify-between items-center">
              <div>
                <h2 class="text-xl font-semibold text-gray-800 font-mono">
                  {{ centro.nombre }}
                </h2>

                <p class="text-sm text-gray-500 font-mono">

                  {{ centro.user.first_name }}
                  {{ centro.user.last_name }} / {{ clasificaciones[centro.clasificacioncentro_id] }}

                </p>

              </div>



            </div>
            <div class=" px-6 py-4 border-b flex justify-between items-center">
              <p class="text-sm text-gray-800 font-mono mt-3">
                I.Detalle ejecución presupuestaria acumulado al cierre del {{ descripcion_libromayor }}.
              </p>
            </div>
            <!-- Tabla -->
            <div class="overflow-x-auto">

              <table class="w-full text-sm" v-if="centro?.presup_ctas?.length">

                <!-- Header tabla -->
                <thead class="bg-gray-100 text-gray-700 uppercase text-xs tracking-wider">
                  <tr>

                    <th class="px-4 py-3 text-center">Agrupación cuentas</th>
                    <th class="px-4 py-3 text-center">Presupuesto {{ año }}</th>
                    <th class="px-4 py-3 text-right">Gastos</th>
                    <th class="px-4 py-3 text-right">Variación</th>
                    <th class="px-4 py-3 text-right">% Ejecución</th>
                  </tr>
                </thead>


                <!-- Body -->
                <tbody>

                  <tr v-for="(p) in centro.presup_ctas" :key="p.categoria_id"
                    class="border-t hover:bg-gray-50 transition font-mono">



                    <td class="px-4 py-2 font-medium text-gray-700">
                      {{ p.nombre_categoria.substr(0, 21) }}
                    </td>

                    <td class="px-4 py-2 text-right font-mono">
                      {{ $formatoMiles(p.total_presupuesto) }}
                    </td>

                    <td class="px-4 py-2 text-right font-mono">
                      {{ $formatoMiles(p.total_gastos) }}
                    </td>

                    <td class="px-4 py-2 text-right font-mono" :class="(p.total_presupuesto - p.total_gastos) >= 0
                      ? 'text-green-600'
                      : 'text-red-600'">
                      {{
                        $formatoMiles(p.total_presupuesto - p.total_gastos)

                      }}
                    </td>

                    <td class="px-4 py-2 text-right">

                      <span class="px-2 py-1 rounded-lg text-xs font-semibold" :class="porcentajeClase(p)">
                        {{ porcentaje(p) }} %
                      </span>

                    </td>

                  </tr>

                </tbody>
                <tfoot class="bg-gray-100 font-semibold border-t-2">

                  <tr>

                    <td colspan="1" class="px-4 py-3 text-right">
                      Totales
                    </td>

                    <td class="px-4 py-3 text-right font-mono">
                      {{ $formatoMiles(sumaPresupuesto(centro.presup_ctas)) }}
                    </td>

                    <td class="px-4 py-3 text-right font-mono">
                      {{ $formatoMiles(sumaGastos(centro.presup_ctas)) }}
                    </td>

                    <td class="px-4 py-3 text-right font-mono" :class="variacionTotal(centro.presup_ctas) >= 0
                      ? 'text-green-600'
                      : 'text-red-600'">
                      {{ $formatoMiles(variacionTotal(centro.presup_ctas)) }}
                    </td>

                    <td class="px-4 py-3 text-right">

                      <span class="px-2 py-1 rounded-lg text-xs" :class="porcentajeClaseTotal(centro.presup_ctas)">
                        {{ porcentajeTotal(centro.presup_ctas) }} %
                      </span>

                    </td>

                  </tr>

                </tfoot>
              </table>

            </div>
            <div class=" px-6 py-4 border-b flex justify-between items-center">

              <p class="text-sm text-gray-800 font-mono mt-3">
                II.Detalle ejecución presupuestaria por centro de costo / cuenta
              </p>
            </div>

            <table class="w-full text-sm mt-3" v-if="centro?.detalle?.presupuestos?.length">
              <!-- Header tabla -->
              <thead class="bg-gray-100 text-gray-700 uppercase text-xs tracking-wider">
                <tr>

                  <th class="px-4 py-3 text-center">Agrupación cuentas</th>
                  <th class="px-4 py-3 text-center">Desc.Cuenta</th>
                  <th class="px-4 py-3 text-right">Presupuesto {{ año }}</th>
                  <th class="px-4 py-3 text-right">Gastos</th>
                  <th class="px-4 py-3 text-right">Variación</th>
                  <th class="px-4 py-3 text-right">% Ejecución</th>
                </tr>
              </thead>


              <!-- Body -->
              <tbody>

                <tr v-for="(p) in centro?.detalle?.presupuestos" :key="p.categoria_id"
                  class="border-t hover:bg-gray-50 transition font-mono">



                  <td class="px-4 py-2 font-medium text-gray-700">
                    {{ p.nombre_categoria.substr(0, 21) }}
                  </td>
                  <td class="px-4 py-2 font-medium text-gray-700">
                    {{ p.nombre_cuenta.substr(0, 21) }}
                  </td>
                  <td class="px-4 py-2 text-right font-mono">
                    {{ $formatoMiles(p.total_presupuesto) }}
                  </td>

                  <td class="px-4 py-2 text-right font-mono">
                    {{ $formatoMiles(p.total_gastos) }}
                  </td>

                  <td class="px-4 py-2 text-right font-mono" :class="(p.total_presupuesto - p.total_gastos) >= 0
                    ? 'text-green-600'
                    : 'text-red-600'">
                    {{
                      $formatoMiles(p.total_presupuesto - p.total_gastos)

                    }}
                  </td>

                  <td class="px-4 py-2 text-right">

                    <span class="px-2 py-1 rounded-lg text-xs font-semibold" :class="porcentajeClase(p)">
                      {{ porcentaje(p) }} %
                    </span>

                  </td>

                </tr>

              </tbody>
              <tfoot class="bg-gray-100 font-semibold border-t-2">

                <tr>

                  <td colspan="2" class="px-4 py-3 text-right">
                    Totales
                  </td>

                  <td class="px-4 py-3 text-right font-mono">
                    <!-- $formatoMiles(sumaPresupuesto(centro.presup_ctas)) -->
                    {{ $formatoMiles(sumaPresupuesto(centro.detalle.presupuestos)) }}

                  </td>

                  <td class="px-4 py-3 text-right font-mono">
                    <!--  $formatoMiles(sumaGastos(centro.presup_ctas)) -->
                    {{ $formatoMiles(sumaGastos(centro.detalle.presupuestos)) }}
                  </td>
                  <!--  {{ $formatoMiles(variacionTotal(centro.presup_ctas)) }} -->
                  <td class="px-4 py-3 text-right font-mono" :class="variacionTotal(centro.presup_ctas) >= 0
                    ? 'text-green-600'
                    : 'text-red-600'">
                    {{ $formatoMiles(variacionTotal(centro.detalle.presupuestos)) }}
                  </td>

                  <td class="px-4 py-3 text-right">
                    <!--  {{ porcentajeTotal(centro.presup_ctas) }} -->
                    <span class="px-2 py-1 rounded-lg text-xs" :class="porcentajeClaseTotal(centro.presup_ctas)">
                      {{ porcentajeTotal(centro.detalle.presupuestos) }} %
                    </span>

                  </td>

                </tr>

              </tfoot>
            </table>

            <div v-else class=" px-6 py-4 border-b flex justify-between items-center">

              <p class="text-sm text-red-800 font-mono mt-3 ">
                {{ `No hay detalle de ejecución presupuestaria en ${this.nomSelectedCuenta}` }}
              </p>
            </div>

          </div>


        </div>

        <!-- ================= FOOTER ================= -->
        <div class="border-t p-4 flex justify-end space-x-4
             text-sm text-gray-600 shrink-0">
          <button @click="exportarPDF" class="bg-blue-600 text-white px-4 py-2 rounded">
            Exportar PDF
          </button>
          <button @click="cerrar" class="bg-gray-300 hover:bg-gray-200 text-gray-900
               px-6 py-2 rounded-lg shadow-sm">
            Cerrar ventana
          </button>
          <!-- 
      <button
        @click="print"
        class="bg-gray-300 hover:bg-gray-200 text-gray-900
               px-6 py-2 rounded-lg shadow-sm"
      >
        Imprimir
      </button> -->
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
import api from "@/api/axios";
import jsPDF from "jspdf"
import autoTable from "jspdf-autotable"
import logo from "@/assets/logo-print.png"
export default {
  name: "ModalDetalleEjecucionPresupuestario",

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    centro_responsable_cuentas: {
      type: Object,
    },
    timestamp: {
      type: String,
    },
    selectedCategoria: {
      type: Number
    },
    selectedCuenta: {
      type: Number
    },
    borrador:{
      type:Boolean
    }
  },
  computed: {
    mesTexto() {
      const meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      return this.mes > 0 ? meses[this.mes - 1] : "";
    },
    nombreMes() {
      const fecha = new Date()

      const mes = new Intl.DateTimeFormat("es-CL", {
        month: "long"
      }).format(fecha)

      return mes.charAt(0).toUpperCase() + mes.slice(1)
    }
  },

  watch: {

    timestamp: function () {
      // this.recargaDatos(this.datosModificacion);
    },
    centro_responsable_cuentas: function (v) {
      this.centro_cuentas = v;
      this.agregaNombres();

    },


  },
  methods: {
 inicializar(){
        this.aa_consulta =  this.$store.state.auth.userLogin.año  
        if (this.borrador)
        {
            this.aa_consulta = this.$store.state.auth.userLogin.año_borrador
        }
    },
    cerrar() {
      this.$emit("update:visible", false);
    },
    formatearFecha(timestamp) {
      const fecha = new Date(timestamp);

      const dd = String(fecha.getDate()).padStart(2, "0");
      const mm = String(fecha.getMonth() + 1).padStart(2, "0");
      const yyyy = fecha.getFullYear();

      const hh = String(fecha.getHours()).padStart(2, "0");
      const mi = String(fecha.getMinutes()).padStart(2, "0");
      const ss = String(fecha.getSeconds()).padStart(2, "0");

      return `${dd}/${mm}/${yyyy} ${hh}:${mi}:${ss}`;
    },
    agregaNombres() {
      /**
       *  this.$store.state.cuentas.cuentas
       [{
                "id":112,
                "codigo":"4.5.1030.80.44",
                "nombre":"Alarma",
                "tipo_cuenta":{
                    "id":13,
                    "nombre":"GTOS BASICOS CASAS E INSTALACIONES",
                    "categoria_cuenta":{
                        "id":8,
                        "nombre":"GASTOS GENERALES",
                        "orden": 3
                    }
                }
          ]   
       */



      /*
      
    this.centro_cuentas=  [ 
    {
        "id": 30,
        "codigo": "VCO041000000000",
        "nombre": "Comunidades Alerce Andino",
        "tiene_presupuesto": true,
        "clasificacioncentro_id": 5,
        "orden": 1,
        "user": {
            "id": 4,
            "first_name": "Carolina",
            "last_name": "Cerda"
        },
        "usuarios": [
            {
                "id": 6,
                "first_name": "Cecilia",
                "last_name": "Brahm"
            },
            
        ],
        "presup_ctas": [
            {
                "categoria_id": 1,
                "centro_id": 30,
                "total_presupuesto": 13930255,
                "total_gastos": 0,
                "nombre_categoria": "GASTOS DEL PERSONAL",
                "orden": 1
            },
        ],

        "detalle": {
            "status": 200,
            "anio": 2026,
            "cantidad": 10,
            "presupuestos": [
                {
                    "id": 211,
                    "centro_id": 30,
                    "cuenta_id": 6,
                    "empresa_id": 1,
                    "aa": 2026,
                    "moneda_id": 1,
                    "total_presupuesto": "350000.00",
                    "total_gastos": "0.00",
                    "categoria_cuenta_id": 1,
                    "categoria_cuenta_orden": 1,
                    "nombre_categoria": "GASTOS DEL PERSONAL",
                    "nombre_cuenta": "Beneficios al Personal"
                } 
            ],
            "descripcion_libromayor": "30 Abril"
        }
    },
  
    
]
  */

      // agrega nombre de categoria_cuenta y ordena por 'Orden'
      this.centro_cuentas.forEach(centro => {
        centro.presup_ctas.forEach(cta => {
          const categoria = this.$store.state.cuentas.cuentas.find(
            c => c.tipo_cuenta.categoria_cuenta.id === cta.categoria_id)
          cta.nombre_categoria = categoria?.tipo_cuenta?.categoria_cuenta?.nombre || '';
          cta.orden = categoria?.tipo_cuenta?.categoria_cuenta?.orden;
        });

        this.centro_cuentas.forEach(centro => {
          (centro.presup_ctas.sort((a, b) => (a.orden ?? 999) - (b.orden ?? 999)))

        });

      });

      // ordena por clasificacioncentro y orden
      this.centro_cuentas.sort(
        (a, b) =>
          a.clasificacioncentro_id - b.clasificacioncentro_id ||
          a.orden - b.orden
      )
      console.log('final', this.centro_cuentas)

      if (this.selectedCuenta > 0) {
        const cta = this.$store.state.cuentas.cuentas.find(c => c.id === this.selectedCuenta);

        this.nomSelectedCuenta = cta.nombre
      }


      this.cargarGastos();

    },
    async cargarGastos() {
      this.loading = true
      try {

        const promesas = this.centro_cuentas.map(async centro => {
          centro.detalle = await this.leeGastosFecha(centro.id)
          return centro
        })
        await Promise.all(promesas)

      } finally {

        this.loading = false

      }
    },
    async leeGastosFecha(centro_id) {
      try {
        // trae presupuestos con o sin movimiento
        const data = {
          centro_id: centro_id,

        }
        if (this.selectedCategoria > 0) {
          data.categoria_id = this.selectedCategoria
        }
        if (this.selectedCuenta > 0) {
          data.cuenta_id = this.selectedCuenta
        }
        if (this.borrador){
          data['borrador'] = this.borrador
         }
        const response = await api.post("api/v1/presupuestos/centro/", data, {
          headers: {
            "Content-Type": "application/json",

          },
        });
        if (response?.status === 200) {
          /**
             *  this.$store.state.cuentas.cuentas
             [{
                      "id":112,
                      "codigo":"4.5.1030.80.44",
                      "nombre":"Alarma",
                      "tipo_cuenta":{
                          "id":13,
                          "nombre":"GTOS BASICOS CASAS E INSTALACIONES",
                          "categoria_cuenta":{
                              "id":8,
                              "nombre":"GASTOS GENERALES",
                              "orden": 3
                          }
                      }
                ]   
            */

          /*  response.data
           {
    "status": 200,
    "anio": 2026,
    "cantidad": 18,
    "presupuestos": [
        {
            "id": 3429,
            "centro_id": 58,
            "cuenta_id": 1,
            "empresa_id": 1,
            "aa": 2026,
            "moneda_id": 1,
            "total_presupuesto": "11670680.00",
            "total_gastos": "0.00",
            "categoria_cuenta_id": 1,
            "categoria_cuenta_orden": 1,
            "nombre_categoria": "GASTOS DEL PERSONAL",
            "nombre_cuenta": "Remuneraciones"
        },
 
       
    ],
    "descripcion_libromayor": "gastos al 31 de mayo"
}
          */
          console.log('data',response.data)
          if (response?.data) 
          {

            this.descripcion_libromayor = response.data.descripcion_libromayor
              ? `${response.data.descripcion_libromayor} ${this.año}`
              : `${this.nombreMes} ${this.año}`;

            this.año = response.data.anio;
            response.data.presupuestos.forEach(presup => {
              const categoria = this.$store.state.cuentas.cuentas.find(c => c.tipo_cuenta.categoria_cuenta.id === presup.categoria_cuenta_id)
              presup.nombre_categoria = categoria?.tipo_cuenta?.categoria_cuenta?.nombre || '';
              const cuenta = this.$store.state.cuentas.cuentas.find(c => c.id === presup.cuenta_id)
              presup.nombre_cuenta = cuenta.nombre || '';
            });

          response.data.presupuestos.sort((a, b) => {

            const ordenCategoria =
              (a.categoria_cuenta_orden ?? 999) -
              (b.categoria_cuenta_orden ?? 999);

            if (ordenCategoria !== 0) {
              return ordenCategoria;
            }

            return (a.nombre_cuenta || '').localeCompare(
              b.nombre_cuenta || '',
              'es',
              { sensitivity: 'base' }
            );
          });
           
            return response.data
          
          }

        }



      } catch (e) {
        console.error('fallo al leer gastos', e)
      }
    },
    ordenaCategoriasCuentas() {


      this.listado = this.$store.state.cuentas.cuentas;
      this.listado.forEach((cuenta) => {
        const cat = cuenta.tipo_cuenta.categoria_cuenta;
        const tip = cuenta.tipo_cuenta;
        const codigocta = cuenta.codigo;
        const idcta = cuenta.id;
        const nomcta = cuenta.nombre;

        /*  
       {
        "id": 38,
        "codigo": "4510305004",
        "nombre": "Viajes de prensa, institucionales",
        "tipo_cuenta": {
            "id": 8,
            "nombre": "COMUNICACIONES y GESTION INSTITUCIONAL",
            "categoria_cuenta": {
                "id": 5,
                "nombre": "COMUNICACIONES y GESTION INSTITUCIONAL",
                "orden": 4
            }
        }
    },
         */

        if (!this.categorias[cat.id]) {
          this.categorias[cat.id] = {
            id: cat.id,
            nombre: cat.nombre,
            tipos: []
          };

        }
        // busca tipos 
        let tipos = this.categorias[cat.id].tipos;
        let existeTipo = tipos.find(tipo => tipo.id === tip.id);
        if (typeof existeTipo == 'undefined') {
          tipos.push({ 'id': tip.id, 'nombre': tip.nombre, 'cuentas': [{ 'id': idcta, 'cod': codigocta, 'nomcta': nomcta }] })
          this.categorias[cat.id].tipos = tipos;
        } else {

          console.log(existeTipo.cuentas)
          existeTipo.cuentas.push({ 'id': idcta, 'cod': codigocta, 'nomcta': nomcta })
          this.categorias[cat.id].tipos.cuentas = existeTipo;

        }

        /*
          categorias
             {
                .id
                .nombre
                 +tipos:{
                    .id
                    .nombre
                    +cuentas[{
                      .id
                      .codigo
                      .nombre
                    }]
                }
              }              
        */
        /*
          {
            "1": {
                "id": 1,
                "nombre": "GASTOS DEL PERSONAL",
                "tipos": [
                    {
                        "id": 1,
                        "nombre": "GASTOS DEL PERSONAL",
                        "cuentas": [
                            {
                                "id": 5,
                                "cod": "4510301005",
                                "nomcta": "Alimentacion del personal"
                            },
                   
                        ]
                    }
                ]
            },*/



      });

    },
    porcentaje(p) {
      if (!p.total_presupuesto) return 0

      return (
        (100 * p.total_gastos) / p.total_presupuesto
      ).toFixed(1)
    },


    porcentajeClase(p) {

      if (!p.total_presupuesto)
        return "bg-gray-200 text-gray-600"

      const porcentaje =
        (100 * p.total_gastos) / p.total_presupuesto

      if (porcentaje < 50)
        return "bg-green-100 text-green-700"

      if (porcentaje < 90)
        return "bg-yellow-100 text-yellow-700"

      return "bg-red-100 text-red-700"
    },

    sumaPresupuesto(ctas) {
      return ctas.reduce(
        (acc, c) => acc + parseFloat(c.total_presupuesto),
        0
      )
    },


    sumaGastos(ctas) {
      return ctas.reduce(
        (acc, c) => acc + parseFloat(c.total_gastos),
        0
      )
    },


    variacionTotal(ctas) {
      return (
        this.sumaPresupuesto(ctas) -
        this.sumaGastos(ctas)
      )
    },


    porcentajeTotal(ctas) {

      const presupuesto = this.sumaPresupuesto(ctas)

      if (!presupuesto) return 0

      return (
        (100 * this.sumaGastos(ctas)) /
        presupuesto
      ).toFixed(1)
    },


    porcentajeClaseTotal(ctas) {

      const porcentaje = this.porcentajeTotal(ctas)

      if (porcentaje < 50)
        return "bg-green-100 text-green-700"

      if (porcentaje < 90)
        return "bg-yellow-100 text-yellow-700"

      return "bg-red-100 text-red-700"
    },
    exportarPDF() {

      const agregarHeader = (doc, centro) => {


        const img = new Image()

        img.src = logo
        doc.addImage(img, "PNG", 370, 15, 136, 60)


        doc.setFont("helvetica", "bold")
        doc.setFontSize(14)
        doc.text(`INFORME GASTOS MENSUAL`, 40, 40)
        doc.text(centro.nombre, 40, 55)
        doc.setFontSize(11)
        doc.setFont("helvetica", "normal")
        doc.text(this.clasificaciones[centro.clasificacioncentro_id], 40, 70)
        doc.text(centro.user.first_name + " " + centro.user.last_name, 40, 82)
        this.nomCentro = centro.nombre

      }
      const doc = new jsPDF("p", "pt", "letter")
      doc.setFont("helvetica", "normal")
      this.centro_cuentas.forEach((centro, indexCentro) => {

        if (indexCentro > 0) {
          doc.addPage()
        }
        agregarHeader(doc, centro)
        let y = 90
        y += 17

        doc.setFontSize(9)
        doc.setFont("helvetica", "normal")
        doc.text('I.Detalle ejecución presupuestaria acumulado al cierre ' + this.descripcion_libromayor, 40, y)
        y += 12;
        // =====================
        // RESUMEN
        // =====================

        autoTable(doc, {
          headStyles:
          {
            fillColor: [255, 255, 255],
            textColor: 0,
            fontStyle: "normal",
            fontSize: 9,
            font: "helvetica"
          },
          bodyStyles: {
            fontSize: 9,
            font: "helvetica",
            textColor: 0,
          },
          startY: y,
          head: [[

            "Agrupación cuentas",
            "Presup.",
            "Gastos",
            "Var.",
            "% Ejec."
          ]],
          body: centro.presup_ctas.map((p) => [

            p.nombre_categoria,
            this.$formatoMiles(p.total_presupuesto),
            this.$formatoMiles(p.total_gastos),
            this.$formatoMiles(
              p.total_presupuesto - p.total_gastos
            ),
            this.porcentaje(p) + " %"

          ]),


          foot: [[


            "Totales",

            this.$formatoMiles(
              this.sumaPresupuesto(centro.presup_ctas)
            ),

            this.$formatoMiles(
              this.sumaGastos(centro.presup_ctas)
            ),

            this.$formatoMiles(
              this.variacionTotal(centro.presup_ctas)
            ),

            this.porcentajeTotal(centro.presup_ctas) + " %"

          ]],

          footStyles: {

            fontStyle: "bold",
            fillColor: [243, 244, 246],
            textColor: 0

          },
          columnStyles: {
            1: { halign: 'right' }, // Presupuesto
            2: { halign: 'right' }, // Gastos
            3: { halign: 'right' }, // Saldo
            4: { halign: 'right' }  // %
          },
          didParseCell: function (data) {
            if (data.section === 'head' && data.column.index > 0) {
              data.cell.styles.halign = 'right';
            }
            if (
              data.section === 'foot' &&
              data.column.index >= 1
            ) {
              data.cell.styles.halign = 'right';
            }
          },

        })


        y = doc.lastAutoTable.finalY + 20
        doc.setFontSize(9)
        doc.setFont("helvetica", "normal")
        y += 9
        doc.text('II.Detalle ejecución presupuestaria por centro de costo / cuenta', 40, y)
        y += 5
        if (centro?.detalle?.presupuestos?.length) {

          autoTable(doc, {
            startY: y,
            head: [[

              "Agrupación cuentas",
              "Desc.Cuenta",
              "Presup.",
              "Gastos",
              "Var.",
              "% Ejec."
            ]],
            headStyles:
            {
              fillColor: [255, 255, 255],
              textColor: 0,
              fontStyle: "normal",
              fontSize: 8,
              font: "helvetica"
            },
            bodyStyles: {
              fontSize: 8,
              font: "helvetica",
              textColor: 0,

            },
            body:
              centro.detalle.presupuestos.map((p) => [

                p.nombre_categoria.substr(0, 21),
                p.nombre_cuenta.substr(0, 25),
                this.$formatoMiles(p.total_presupuesto),
                this.$formatoMiles(p.total_gastos),
                this.$formatoMiles(
                  p.total_presupuesto - p.total_gastos
                ),
                this.porcentaje(p) + " %"
              ]
              ),

            foot: [[

              {
                content: "Totales",
                colSpan: 2,

              },

              this.$formatoMiles(
                this.sumaPresupuesto(centro.detalle.presupuestos)
              ),

              this.$formatoMiles(
                this.sumaGastos(centro.detalle.presupuestos)
              ),

              this.$formatoMiles(
                this.variacionTotal(centro.detalle.presupuestos)
              ),

              this.porcentajeTotal(
                centro.presup_ctas
              ) + " %"

            ]],
            footStyles: {
              fontStyle: "bold",
              fillColor: [243, 244, 246],
              textColor: 0

            },
            columnStyles: {
              2: { halign: 'right' }, // Presupuesto
              3: { halign: 'right' }, // Gastos
              4: { halign: 'right' }, // Saldo
              5: { halign: 'right' }  // %
            },
            didParseCell: function (data) {
              if (data.section === 'head' && data.column.index > 1) {
                data.cell.styles.halign = 'right';
              }
              if (
                data.section === 'foot' &&
                data.column.index >= 1
              ) {
                data.cell.styles.halign = 'right';
              }
            },
            showFoot: 'lastPage'

          })

        } else {
          y += 12
          doc.text('No hay detalle de ejecución presupuestaria en ' + this.nomCentro + ' -> ' + this.nomSelectedCuenta, 40, y)
        }

      })

      const totalPaginas = doc.getNumberOfPages()
      doc.setFontSize(7)
      for (let i = 1; i <= totalPaginas; i++) {
        doc.setPage(i)
        doc.text(`Página ${i} de ${totalPaginas}`, doc.internal.pageSize.width - 100, doc.internal.pageSize.height - 20)
      }

      doc.save("ejecucion_presupuestaria.pdf")

    }
  },
  data() {
    return {
      aa_consulta:0,
      loading: false,
      ingresos: [],
      modificaciones: [],
      meses: [
        "Ene.",
        "Feb.",
        "Mar.",
        "Abr.",
        "May.",
        "Jun.",
        "Jul.",
        "Ago.",
        "Sept.",
        "Oct.",
        "Nov.",
        "Dic.",
      ],

      mes: 0,
      nomcentro: "",
      nomcta: "",
      nommes: " ",

      centro_id: 0,
      cuenta_id: 0,
      centro_cuentas: [],
      saldo: 0,
      DJANGO_APP_API_URL: '',
      ultimo_id_modificacion: 0,
      cuentas: [],
      año: '',
      descripcion_libromayor: '',
      clasificaciones: [],
      nomSelectedCuenta: '',
      nomCentro: ''
    };
  },
  mounted() {
   // console.log('mounted!');
    this.DJANGO_APP_API_URL = process.env.VUE_APP_DJANGO_API_URL
    this.clasificaciones = JSON.parse(process.env.VUE_APP_CLASIF_CENTRO)
   // console.log("clasificaciones", this.clasificaciones)
    this.centro_cuentas = []

    this.agregaNombres()
  },
};
</script>
